import { useFormik } from 'formik'
import * as Yup from 'yup'
import { FormattedMessage, useIntl } from 'react-intl'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import FormikTextField from '../../../../shared/components/formik/FormikTextField'

const LabelForm = ({ label, createLabel, updateLabel, onSuccess, onCancel }) => {
  const intl = useIntl()
  const isEditMode = Boolean(label)

  const validationSchema = Yup.object({
    key: Yup.string().required(intl.formatMessage({ id: 'login.error.required' })),
    value: Yup.string().required(intl.formatMessage({ id: 'login.error.required' }))
  })

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      key: label?.key || '',
      value: label?.value || ''
    },
    validationSchema,
    onSubmit: (values, { setSubmitting, setStatus }) => {
      const labelData = {
        serviceLabel: {
          key: values.key,
          value: values.value
        }
      }

      const apiCall = isEditMode
        ? updateLabel(label.id, labelData)
        : createLabel(labelData)

      apiCall
        .then(() => {
          onSuccess()
        })
        .catch((err) => {
          setStatus(err.message || 'Error saving label')
        })
        .finally(() => {
          setSubmitting(false)
        })
    }
  })

  return (
    <Box component="form" onSubmit={formik.handleSubmit}>
      <FormikTextField
        formik={formik}
        name="key"
        label={<FormattedMessage id="labels.form.keyLabel" />}
        autoFocus
      />

      <Box sx={{ mt: 2 }}>
        <FormikTextField
          formik={formik}
          name="value"
          label={<FormattedMessage id="labels.form.valueLabel" />}
        />
      </Box>

      {formik.status && (
        <Typography color="error" sx={{ mt: 2 }}>
          {formik.status}
        </Typography>
      )}

      <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
        <Button
          variant="outlined"
          onClick={onCancel}
          disabled={formik.isSubmitting}
        >
          <FormattedMessage id="app.actions.cancel.label" />
        </Button>
        <Button
          color="primary"
          variant="contained"
          type="submit"
          disabled={formik.isSubmitting}
        >
          <FormattedMessage id="labels.form.submitButton" />
        </Button>
      </Box>
    </Box>
  )
}

export default LabelForm
